export const transformCardResponse = (response, cardId) => {
  const card = response?.data || {};
  console.log({abc:Array.isArray(response?.suggestions)});
  
  const listings = Array.isArray(response?.listing) ? response.listing : [];
  const recommendations = Array.isArray(response?.suggestions)
    ? response.suggestions
    : [];
  console.log({recommendations});
  
  // const listingImages = listings.flatMap((l) =>
  //   Array.isArray(l?.images) ? l.images.map((img) => img?.image || "") : []
  // );
  const listingImages = [card.imageUrl];

  const firstListing = listings[0] || {};

  // Transform real listings
  const transformedListings = listings.map((item) => ({
    ...item,
    id: item?.id || null,
    sellarAccount: item?.seller,
    setName: response?.data?.setName || "Unknown Set",
    seller:
      item?.seller?.store_name ||
      `${item?.seller?.first_name || ""} ${
        item?.seller?.last_name || ""
      }`.trim() ||
      "Unknown Seller",
    rating: item?.seller_rating_stats?.rating_out_of_5
      ? item.seller_rating_stats.rating_out_of_5 * 20
      : (Number(item?.seller?.rating) || 100),
    sales: item?.seller_rating_stats?.completed_orders ?? (item?.seller?.sales || 0),
    condition: item?.condition || "Unknown",
    price: parseFloat(item?.price || 0),
    shipping: 0,
    quantity: item?.quantity,
    images: item.images,
  }));

  return {
    ...card,
    id: card?.id || cardId || null,
    name: card?.productName || "Unknown Card",
    price: parseFloat(card?.marketPrice?.[0]?.price || 0),
    images:
      listingImages.length > 0
        ? listingImages
        : [
            "https://pbs.twimg.com/media/Gb3hPTXWQAA74Nc?format=jpg&name=4096x4096",
          ],
    tags: [
      card?.rarity || "Unknown",
      card?.setName || "Unknown Set",
      card?.cardNumber || "#N/A",
    ],
    negotiable: true,
    condition: firstListing?.condition || "Unknown",
    description: firstListing?.description || "No Description Available",
    seller: {
      name:
        firstListing?.seller?.store_name ||
        `${firstListing?.seller?.first_name || ""} ${
          firstListing?.seller?.last_name || ""
        }`.trim() ||
        "Unknown Seller",
      rating: firstListing?.seller_rating_stats?.rating_out_of_5
        ? firstListing.seller_rating_stats.rating_out_of_5
        : 5,
      sales: firstListing?.seller_rating_stats?.completed_orders ?? (firstListing?.seller?.sales || 0),
      avatar:
        firstListing?.images?.[0]?.image ||
        "https://pbs.twimg.com/media/Gb3hPTXWQAA74Nc?format=jpg&name=4096x4096",
    },
    listings: [...transformedListings],
    recommendations: recommendations.map((rec) => ({
      id: rec?.id || null,
      card_id: rec?.card_id || null,
      name: rec?.product_name || "Unknown",
      set: rec?.set_name || "Unknown Set",
      rarity: rec?.rarity || "Unknown",
      price: parseFloat(rec?.lowest_price || 0),
      marketPrice: parseFloat(rec?.lowest_price || 0),
      image: rec?.image_url || "",
    })),
  };
};

export const transformListDetailsResponse = (response) => {
  if (!response?.success) return null;

  const { listing, recommendations, seller_other_listings } = response;

  return {
    // Base listing info
    listing,
    id: listing.id,
    name: listing.card_name || listing.product_name || "Unknown Card",
    price: Number(listing.price) || 0,
    images: listing.images?.map((img) => img.image) || [],
    condition: listing.condition || "Unknown",
    description: listing.description || "No description available",
    negotiable: Boolean(listing.negotiable) ?? true,

    // Simple tags you can later enhance (set, condition, id)
    tags: [
      listing.condition || "Unknown Condition",
      listing.set_name || "Unknown Set",
      `#${listing.id || "N/A"}`,
    ],

    // Seller info
    seller: {
      id: listing.seller?.id || null,
      name:
        listing.seller?.store_name ||
        `${listing.seller?.first_name || ""} ${
          listing.seller?.last_name || ""
        }`.trim() ||
        "Unknown Seller",
      store_name: listing.seller?.store_name || "",
      avatar:
        listing.seller?.store_logo ||
        "https://pbs.twimg.com/media/Gb3hPTXWQAA74Nc?format=jpg&name=4096x4096",
      rating: listing.seller_rating_stats?.rating_out_of_5 
        ? listing.seller_rating_stats.rating_out_of_5 * 20 
        : (Number(listing.seller?.rating) || 0),
      sales: listing.seller_rating_stats?.completed_orders 
        ?? (Number(listing.seller?.sales) || 0),
      seller_rating_stats: listing.seller_rating_stats || listing.seller?.seller_rating_stats || null,
      shipping_policy: listing.seller?.shipping_policy || "",
      phone_number: listing.seller?.phone_number || "",
      city: listing.seller?.city || "",
    },

    // Market history placeholder (can be expanded if API provides data)
    marketHistory: {
      currentPrice: Number(listing.price) || 0,
      change: 0,
      data: [],
    },

    // Recommendations (from API)
    recommendations:
      recommendations?.map((item) => ({
        id: item.id,
        card_id: item.card_id || null,
        name: item.card_name || item.product_name || "Unknown Card",
        set: item.set_name || "",
        rarity: item.rarity || "",
        price: Number(item.lowest_price) || 0,
        marketPrice: Number(item.lowest_price) || 0,
        image: item.image_url || "",
        condition: item.condition || "",
      })) || [],

    // Seller’s other listings
    sellerOtherListings:
      seller_other_listings?.map((item) => ({
        id: item.id,
        card_id: item.card_id || null,
        name: item.card_name || "Unknown Card",
        set: item.set_name || "",
        rarity: item.rarity || "",
        price: Number(item.price) || 0,
        marketPrice: Number(item.price) || 0,
        image: item.images?.[0]?.image || "",
        condition: item.condition || "Unknown",
        description: item.description || "",
      })) || [],
  };
};
